
import { Preset } from './api/models/preset';
import { Vector2, Vector3, Quaternion } from '@babylonjs/core';
import { SlotItem } from './slotItem';
// @ts-ignore
import { presetData } from './api/mock/preset.js';
import { ElementType, SpecyficType } from './element';
import { i18n } from '@/plugins/i18n';
import store from '@/store';

export enum PresetStep {
    COMPLEX,
    INNER
}

export enum PresetType {
    PRESET,
    NEW
}

export class PresetData {

    public static adapt(input: any): PresetData {
        const shaders = input.shaders;
        const elements = input.elements.map((x: any) => ElementPresetData.adapt(x));
        return new PresetData(shaders, elements);
    }

    constructor(
        public shaders: ShadersPresetData,
        public elements: ElementPresetData[],
    ) { }
}

export class ShadersPresetData {

    constructor(
        public selectedHandleName: string,
        public selectedFrontName: string,
        public selectedWallName: string,
        public selectedShelfName: string,
        public selectedBodyName: string,
        public selectedLegsName: string,
        public selectedRafixName: string,
        public selectedSupportName: string,
        public selectedFrameName: string,
    ) { }
}

export class ElementPresetData {

    public static adapt(input: any): ElementPresetData {
        const model = input.model;
        const light = input.light;
        const type = input.type || ElementType.OTHER;
        const specyficType = input.specyficType || SpecyficType.OTHER;
        const shaderName = input.shaderName;
        const position = new Vector2(input.position.x, input.position.y);
        const shape = new Vector2(input.shape.x, input.shape.y);
        const center = new Vector3(
            input.center.x,
            input.center.y,
            input.center.z,
        );
        const rotation = new Quaternion(
            input.rotation.x,
            input.rotation.y,
            input.rotation.z,
            input.rotation.w,
        );
        let slot: SlotItem | undefined = undefined;
        if (input.slot !== undefined) {
            const slotPosition = new Vector2(
                input.slot.position.x,
                input.slot.position.y,
            );
            const slotShape = new Vector2(
                input.slot.shape.x,
                input.slot.shape.y,
            );
            slot = new SlotItem(
                input.slot.url,
                slotPosition,
                slotShape,
            );
        }
        const bindings = input.bindings;
        return new ElementPresetData(
            model,
            light,
            type,
            specyficType,
            shaderName,
            position,
            shape,
            center,
            rotation,
            slot,
            bindings,
        );
    }

    constructor(
        public model: string,
        public light: string,
        public type: ElementType,
        public specyficType: SpecyficType,
        public shaderName: string,
        public position: Vector2,
        public shape: Vector2,
        public center: Vector3,
        public rotation: Quaternion,
        public slot: SlotItem | undefined,
        public bindings: number[] = [],
    ) { }

    public get cantBeLoaded(): boolean {
        return (
            false
        );
    }
}

export class PresetMenuItem {
    constructor(
        public avatar: string,
        public text: string,
        public productName: string,
        public step: PresetStep,
        public type: PresetType,
        public data: PresetData,
        public selected: boolean = false
    ) { }
}

const data: PresetData = PresetData.adapt(presetData);

class PresetsManager {
    constructor(public presetItems: PresetMenuItem[] = []) {

    }

    public get indexOfSelectedPreset(): number {
        const selectedPreset = store.getters.scene.selectedPreset;
        const index = this.presetItems.indexOf(selectedPreset);
        return index <= 2 ? index : index - 1;
    }

    private haveToAddCreateButton(productId: string): boolean {
        // todo: nazwy projektów które nie mają posiadać guzika stwórz własny.
        var noItemsProject = ['l_90', 'l_120', 'l_140', 'l_160', 'l_180', 's', 'sk', 'ska', 'skk'];
        return noItemsProject.indexOf(productId) === -1;
    }

    public AddCompletePresets(presets: Preset[], productId: string): void {
        presets.forEach(x => this.presetItems.push(
            new PresetMenuItem(
                x.avatar + '.jpg',
                x.name,
                x.projectId,
                PresetStep.COMPLEX,
                PresetType.PRESET,
                PresetData.adapt(JSON.parse(x.projectJson))))
        );

        if (this.haveToAddCreateButton(productId)) {
            const avatar = 'own.svg';
            const text = i18n.t('createYourOwn').toString()
            const preset = new PresetMenuItem(avatar, text, productId, PresetStep.COMPLEX, PresetType.NEW, data);
            this.presetItems.push(preset);
        }
    }

    public AddInnerPresets(presets: Preset[]): void {
        presets.forEach(x => {
            if (x.presetId != 'empty') {
                this.presetItems.push(
                    new PresetMenuItem(
                        x.avatar + '.jpg',
                        x.name,
                        x.projectId,
                        PresetStep.INNER,
                        PresetType.PRESET,
                        PresetData.adapt(JSON.parse(x.projectJson))))
            }
        });
    }
}

export const presets: PresetsManager = new PresetsManager();
